import { faCaretDown, faCaretRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'components/button/Button';
import * as React from 'react';
import { useState } from 'react';

export type DisclosureProps = {
    initialOpen?: boolean;
    summary?: React.ReactNode;
    children: React.ReactNode;
    summaryClassName?: string;
    style?: React.CSSProperties;
};

export function Disclosure({
    children,
    initialOpen,
    summary,
    summaryClassName,
    style,
}: DisclosureProps) {
    const [open, setOpen] = useState(initialOpen ?? false);

    return (
        <div style={style}>
            <Button
                type="button"
                aria-expanded={open}
                onClick={() => setOpen(!open)}
                className={summaryClassName}
            >
                {summary}
                <FontAwesomeIcon
                    className="px-5"
                    icon={open ? faCaretDown : faCaretRight}
                />
            </Button>
            <div style={{ display: open ? 'block' : 'none' }}>{children}</div>
        </div>
    );
}
